import React, { FC } from 'react';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import { TLightFooterLink } from '../../types/lightFooter.types';

const Navigation: FC<any> = (props) => {
    const items = props?.fields?.map((item: TLightFooterLink) => {
        return (
            <li key={item?.id} className="light-footer-navigation__item">
                {item?.fields?.isModalPopup?.value ? (
                    // external consent cookie notice button
                    <button id="ot-sdk-btn" className="ot-sdk-show-settings light-footer-navigation__cookieBtn">
                        {item?.fields?.link?.value?.text || item?.fields?.link?.value?.href}
                    </button>
                ) : (
                    <RoutableSitecoreLink field={item?.fields?.link} className="light-footer-navigation__link" />
                )}
            </li>
        );
    });
    return <ul className="light-footer-navigation">{items}</ul>;
}

export default Navigation;